<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <v-btn class="mr-4" fab dark small color="primary">
          <v-icon dark x-small>
            mdi-share-variant-outline
          </v-icon>
        </v-btn>

        <span class="text-h5">Get Link</span>
      </v-card-title>
      <v-card-text>
        <template>
          <v-row class="ma-0 pa-0 mt-5">
            <v-col cols="12" class="ma-0 pa-0">
              <v-text-field
                outlined
                dense
                type="text"
                readonly
                v-model="generatedURL"
                id="copy-url"
              >
                <template v-slot:append-outer>
                  <v-btn text color="primary" class="mt-n2" @click="copyUrl">
                    Copy
                  </v-btn>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="close" class="mb-1">
          done
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },

    generatedURL: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("close");
    },
    copyUrl() {
      var copyText = document.getElementById("copy-url");
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      navigator.clipboard.writeText(this.generatedURL);
    },
  },
};
</script>
